import {
  applyMiddleware,
  combineReducers,
  compose,
  configureStore,
} from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import user_auth_slice from "./slice/user_auth_slice";
import StoreManagementSlice from "./slice/StoreManagementSlice";
import OrderManagementSlice from "./slice/OrderManagementSlice";
import ProductManagementSlice from "./slice/ProductManagementSlice";
import CustomerManagementSlice from "./slice/CustomerManagemetSlice"
import ReportSlice from "./slice/ReportsSlice"
import VariantSlice from "./slice/variantSlice";

let reducers = combineReducers({
  userAuth: user_auth_slice,
  storeManagement: StoreManagementSlice,
  customerManagement: CustomerManagementSlice,
  reportsManagment: ReportSlice,
  orderManagement: OrderManagementSlice,
  productManagement: ProductManagementSlice,
  variants: VariantSlice,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = configureStore(
  { reducer: reducers },
  composeEnhancers(applyMiddleware(thunk))
);
export default store;
